import Header from "../Header/Navbar"
import Footer from "../Footer/Footer";

import './Shippingpolicy.css'
const ShippingPolicyPage:React.FC = () => {
  return (
    <>
  
    <div className="shippingPolicySection">
      <h2>Shipping & Delivery Policy</h2>
      <p style={{ marginLeft: "10px" }}>
        Contact us at: <a href="mailto:customer.care@gangasupermarket.in">customer.care@gangasupermarket.in</a>
      </p>

      <h3>1. General Overview</h3>
      <ul>
        <li>This policy governs all shipping and delivery matters for business-to-customer (B2C) orders.</li>
      </ul>

      <h3>2. Delivery Charges</h3>
      <ul>
        <li>Delivery charges are shown at checkout before payment.</li>
        <li>We partner with logistics providers to offer low shipping rates.</li>
        <li>Ganga Supermarket bears most of the shipping cost; customers pay only a minimal portion.</li>
        <li>Charges are based on the total cart value and follow slab rates:</li>
      </ul>

      <div style={{ marginLeft: "20px" }}>
        <table className="shippingRateTable">
          <thead>
            <tr>
              <th>Final Cart Value</th>
              <th>Shipping Cost</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>₹0 to ₹500</td>
              <td>₹60.00</td>
            </tr>
            <tr>
              <td>₹501 to ₹1,000</td>
              <td>₹55.00</td>
            </tr>
            <tr>
              <td>₹1,001 to ₹1,500</td>
              <td>₹50.00</td>
            </tr>
            <tr>
              <td>₹1,501 to ₹2,000</td>
              <td>₹40.00</td>
            </tr>
            <tr>
              <td>Above ₹2,001</td>
              <td><strong>FREE</strong></td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3>3. Dispatch Time</h3>
      <ul>
        <li>Orders are typically dispatched within 2–5 working days of placement.</li>
      </ul>

      <h3>4. Delivery Time</h3>
      <ul>
        <li>Domestic deliveries take approximately 5 working days from the date of dispatch.</li>
        <li>Orders are delivered to the address provided at checkout.</li>
        <li>Delays may occur due to unforeseen circumstances.</li>
      </ul>

      <h3>5. Damaged or Defective Goods</h3>
      <ul>
        <li>Notify us within 24 hours if goods are damaged, defective, or incorrect.</li>
        <li>Please refer to our <strong>Returns & Exchange Policy</strong> for further steps.</li>
      </ul>

      <h3>6. Product Returns</h3>
      <ul>
        <li>Customers are responsible for return shipping costs.</li>
        <li>Refer to the <strong>Returns & Exchange Policy</strong> for full return process details.</li>
      </ul>
    </div>
    <Footer/>
    </>
  );
};

export default ShippingPolicyPage;
